import React from 'react';
import { DS_border as coreBorder } from 'mui/base/theme/DS_Tokens/core';
import { DS_spacing as coreSpacing } from 'mui/base/theme/DS_Tokens/core';
import { DS_palette as corePalette } from 'mui/base/theme/DS_Tokens/core';
import { StyledBox } from './DS_BasicCardStyles';

const DS_BasicCard = ({
  children,
  onClick,
  borderWidth = coreBorder.width.xs,
  borderRadius = coreBorder.radius.lg,
  padding = coreSpacing.rem.md,
  backgroundColor = corePalette.white[50],
  backgroundImage,
  sx = {},
}) => (
  <StyledBox
    onClick={onClick}
    sx={{ ...sx }}
    $borderWidth={borderWidth}
    borderRadius={borderRadius}
    padding={padding}
    backgroundColor={backgroundColor}
    $backgroundImage={backgroundImage}
  >
    {children}
  </StyledBox>
);

export default DS_BasicCard;
